import { INSURANCE_TYPES } from '@zocdoc/components/src/constants/constants';
import {
    VISION_INSURANCE_SPECIALTIES,
    DENTAL_INSURANCE_SPECIALTIES,
} from '@zocdoc/components/src/constants/specialties';

export const insuranceTypeFromProvider = provider => {
    const specialtyIds = (provider.specialties || []).map(s => s.id);
    return insuranceTypeFromSpecialtyIds(specialtyIds);
};

export const insuranceTypeFromSpecialtyId = specialtyId => {
    return insuranceTypeFromSpecialtyIds([specialtyId]);
};

const insuranceTypeFromSpecialtyIds = specialtyIds => {
    if (specialtyIds.some(id => DENTAL_INSURANCE_SPECIALTIES.has(id))) {
        return INSURANCE_TYPES.DENTAL;
    } else if (specialtyIds.some(id => VISION_INSURANCE_SPECIALTIES.has(id))) {
        return INSURANCE_TYPES.VISION;
    } else {
        return INSURANCE_TYPES.HEALTH;
    }
};
